// extracted by css-extract-rspack-plugin
export default {"label":"Stepper_label__fNPSL","link":"Stepper_link__PU6SW","stepper":"Stepper_stepper__WvQNI","stepRoot":"Stepper_stepRoot__tywxj"};